import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";

import 'swiper/swiper-bundle.min.css';
import { maxWidth } from '@mui/system';


const myComponentStyle = {
    maxWidth: '100% !important',
  };

export const HomeSlider = () => {
    
    
  return (
    <div className='homeSlider py-4'>
        <div className='container ' style={myComponentStyle}>
        <div className=''><img src='/assets/img/banner/banner-3.jpg'></img></div> 

        {/* <Swiper 
                loop={true}
                spaceBetween={30} 
                navigation={true} 
                modules={[Navigation,Autoplay]}
                autoplay={{delay:1000,
                    disableOnInteraction:false
                }}
                speed={2000}
                className="sliderHome">
            <SwiperSlide className=''>
                <div className='' style={{ 'border-radius':'25px; border: 2px solid #2322221c'}}><img src='/assets/img/banner/banner-1.jpg'></img></div>
            </SwiperSlide>
            <SwiperSlide className=''>
                <div style={{ 'border': '2px solid #2322221c;', 'border-radius':'25px'}}><img src='/assets/img/banner/banner-2.jpg'></img></div>
            </SwiperSlide>
            <SwiperSlide className=''>
                <div className='item rounded-[20px] overflow-hidden'><img src='/assets/img/banner/banner-3.jpg'></img></div> 
            </SwiperSlide>
            <SwiperSlide className=''>
                <div className='item rounded-[20px] overflow-hidden'><img src='/assets/img/banner/banner-4.jpg'></img></div> 
            </SwiperSlide>
        </Swiper> */}
        </div>
      </div>
  )
}

export default HomeSlider;